import Symbol from "./Symbol";
import { INSPECTOR_INDUCTION_MOTOR } from "../../../constants/inspectorConstants";

// Motor de inducción
class InductionMotor extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("InductionMotor", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo"  },
            ratedPower: { isVisible: false, value: null, label: "Potencia Nominal" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            powerFactor: { isVisible: false, value: null, label: "Factor de Potencia" },
            efficiency: { isVisible: false, value: null, label: "Eficiencia" },
            rpm: { isVisible: false, value: null, label: "RPM's" },
            chargeFactor: { isVisible: false, value: null, label: "Factor de carga" },
            serviceFactor: { isVisible: false, value: null, label: "Factor de servicio" },
        };                
    }

    getInspector() {
        return INSPECTOR_INDUCTION_MOTOR;
    }
}

export default InductionMotor;
